// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__S1VDT","requiredAsterisk":"Info_requiredAsterisk__1cSRn"};